<template>
  <div class="auth-container">
    <div class="auth-card">
      <!-- Logo and Name -->
      <div class="logo-section">
        <img src="/graphGPT/LogoKM.png" alt="Logo" class="logo" style="background-color: cadetblue;border-radius: 15px;"/>
        <h1 style="font-family: Merriweather;font-size: 25px;margin-top: 5px;color: darkslategrey;">asK-Y</h1>
      </div>

      <!-- Toggle Buttons for Forms -->
      <div class="form-toggle">
        <button
          :class="{ active: activeForm === 'login' }"
          @click="activeForm = 'login'"
        >
          Login
        </button>
        <button
          :class="{ active: activeForm === 'register' }"
          @click="activeForm = 'register'"
        >
          Register
        </button>
      </div>

      <!-- Login Form -->
      <form v-if="activeForm === 'login'" @submit.prevent="login">
        <div class="form-group">
          <input v-model="email" type="email" placeholder="Email" required />
        </div>
        <div class="form-group">
          <input
            v-model="password"
            type="password"
            placeholder="Password"
            required
          />
        </div>
        <button type="submit" class="btn">Login</button>
      </form>

      <!-- Register Form -->
      <form v-if="activeForm === 'register'" @submit.prevent="register">
        <div class="form-group">
          <input
            v-model="username"
            type="text"
            placeholder="Username"
            required
          />
        </div>
        <div class="form-group">
          <input v-model="email" type="email" placeholder="Email" required />
        </div>
        <div class="form-group">
          <input
            v-model="password"
            type="password"
            placeholder="Password"
            required
          />
        </div>
        <button type="submit" class="btn">Register</button>
      </form>
    </div>
  </div>
</template>

<script>
 import api from "@/api";

export default {
  name: "AuthPage",
  data() {
    return {
      activeForm: "login", // "login" is default; can also be "register"
      username: "",
      email: "",
      password: "",
    };
  },
  methods: {
    async login() {
        const { data } = await api.post("/auth/login", { email: this.email, password: this.password });
        localStorage.setItem("token", data.token);
        this.$router.push("/dashboard");
      },
      async register() {
        await api.post("/auth/register", { username: this.username, email: this.email, password: this.password });
        alert("Registration successful! Please log in.");
      },
  },
};
</script>

<style scoped>
/* Container for centering the card on the page */
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 85vh;
  background: linear-gradient(135deg, #74ebd5, #acb6e5);
}

/* Card style */
.auth-card {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 320px;
}

/* Logo and name styling */
.logo-section {
  text-align: center;
  margin-bottom: 1.5rem;
}
.logo {
  width: 50px;
  height: 50px;
}
.logo-section h1 {
  font-size: 1.5rem;
  margin-top: 0.5rem;
}

/* Form toggle buttons */
.form-toggle {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}
.form-toggle button {
  background: none;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 1rem;
  transition: color 0.3s;
}
.form-toggle button.active {
  color: #3498db;
  font-weight: bold;
  border-bottom: 2px solid #3498db;
}

/* Input field styling */
.form-group {
  margin-bottom: 1rem;
}
.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: border-color 0.3s;
}
.form-group input:focus {
  outline: none;
  border-color: #3498db;
}

/* Button styling */
.btn {
  width: 100%;
  padding: 0.75rem;
  background: #3498db;
  border: none;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s;
}
.btn:hover {
  background: #2980b9;
}
</style>


<!-- <template>
    <div>
      <form @submit.prevent="login">
        <h2>Login</h2>
        <input v-model="email" type="email" placeholder="Email" required />
        <input v-model="password" type="password" placeholder="Password" required />
        <button type="submit">Login</button>
      </form>
      <form @submit.prevent="register">
        <h2>Register</h2>
        <input v-model="username" type="text" placeholder="Username" required />
        <input v-model="email" type="email" placeholder="Email" required />
        <input v-model="password" type="password" placeholder="Password" required />
        <button type="submit">Register</button>
      </form>
    </div>
  </template>
  
  <script>
  import api from "@/api";
  
  export default {
    data() {
      return {
        username: "",
        email: "",
        password: "",
      };
    },
    methods: {
      async login() {
        const { data } = await api.post("/auth/login", { email: this.email, password: this.password });
        localStorage.setItem("token", data.token);
        this.$router.push("/dashboard");
      },
      async register() {
        await api.post("/auth/register", { username: this.username, email: this.email, password: this.password });
        alert("Registration successful! Please log in.");
      },
    },
  };
  </script>
   -->